export default __webpack_public_path__ + "static/media/perso.f40c0257.png";